// React
import { useContext } from "react";

// styles
import "./SideDrawer.scss";

// constants
import {
  SIDE_DRAWER_CHILDREN_ROUTES,
  SIDE_DRAWER_ROUTES,
} from "../../constants/routes";

// helpers
import { getCurrentRoute } from "../../helpers/routes/getCurrentRoute/getCurrentRoute";
import { SideDrawerRoles } from "../../helpers/sideDrawerRoles/SideDrawerRoles";

// hooks
import { useSideDrawerCounts } from "../../hooks/useSideDrawerCounts";

// context
import { SideDrawerContext } from "../../context/SideDrawerContext";

// icons
import { LeftCircleOutlined, RightCircleOutlined } from "@ant-design/icons";

// components
import { Layout, Menu } from "antd";
import Logo from "../logo/Logo";
import { AuthContext } from "../../context/AuthContext";

const SideDrawer = () => {
  // sideDrawer context
  const siderContext = useContext(SideDrawerContext);

  // get Default Opened SubMenues
  const getDefaultOpenedSubMenues = () => {
    for (const [key, value] of Object.entries(SIDE_DRAWER_CHILDREN_ROUTES)) {
      for (let val of value) {
        if (val.path === getCurrentRoute()) {
          return [key];
        }
      }
    }
  };

  // sideDrawer dashboard items count
  const sideDrawerItemsCounts = useSideDrawerCounts();

  const {
    state: {
      userAccess: { moduleList },
    },
  } = useContext(AuthContext);

  return (
    <Layout.Sider
      trigger={null}
      collapsible
      collapsed={siderContext.collapsed}
      breakpoint="lg"
      collapsedWidth="80"
      onCollapse={() => {
        siderContext.collapse();
      }}
    >
      <Logo />

      <div className="rounded-circle d-flex justify-content-center align-items-center sider-toggler">
        {siderContext.collapsed ? (
          <RightCircleOutlined onClick={siderContext.deCollapse} />
        ) : (
          <LeftCircleOutlined onClick={siderContext.collapse} />
        )}
      </div>

      <Menu
        mode="inline"
        defaultSelectedKeys={[getCurrentRoute()]}
        defaultOpenKeys={getDefaultOpenedSubMenues()}
        items={
          SIDE_DRAWER_ROUTES.filter((route) =>
            moduleList?.some((item) => item.key === route.key)
          ).map((route) =>
            SideDrawerRoles(route, sideDrawerItemsCounts, moduleList)
          ) || []
        }
      />
    </Layout.Sider>
  );
};

export default SideDrawer;
